import PropTypes from 'prop-types';
import { ALIGNMENT_OPTIONS } from './alignment';
import { Link } from 'react-router-dom';

export const CHILDREN_PROPTYPES = PropTypes.oneOfType([
  PropTypes.node,
  PropTypes.arrayOf(PropTypes.node)
]);

export const ALIGNMENT_PROPTYPES = PropTypes.oneOf(ALIGNMENT_OPTIONS);

export const BUTTON_COMPONENT_PROPTYPES = PropTypes.oneOf([Link, 'a']);

export const MENU_ITEM_PROPTYPES = {
  name: PropTypes.string,
  description: PropTypes.string,
  spicy: PropTypes.bool,
  vegetarian: PropTypes.bool,
  vegan: PropTypes.bool,
  kosher: PropTypes.bool,
  halal: PropTypes.bool,
  organic: PropTypes.bool,
  dairy: PropTypes.bool,
  peanut: PropTypes.bool,
  tree_nut: PropTypes.bool,
  dairy_free: PropTypes.bool,
  peanut_free: PropTypes.bool,
  tree_nut_free: PropTypes.bool,
  egg: PropTypes.bool,
  shellfish: PropTypes.bool,
  wheat: PropTypes.bool,
  egg_free: PropTypes.bool,
  shellfish_free: PropTypes.bool,
  gluten_free: PropTypes.bool,
  fish: PropTypes.bool,
  soy: PropTypes.bool,
  fish_free: PropTypes.bool,
  soy_free: PropTypes.bool,
  calories: PropTypes.number
};

/* all online ordering locations are associated with an online ordering location */
const BOX_LOCATION_PROPTYPES = PropTypes.shape({
  lat: PropTypes.string,
  lng: PropTypes.string,
  street: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  postal_code: PropTypes.string,
  phone_number: PropTypes.string
});

export const ONLINE_ORDERING_LOCATION_PROPTYPES = PropTypes.shape({
  title: PropTypes.string,
  location: BOX_LOCATION_PROPTYPES.isRequired,
  description: PropTypes.string,
  is_closed: PropTypes.bool,
  distance_to_address: PropTypes.string
});

export const LOCATION_LIST_PROPTYPES = PropTypes.arrayOf(
  ONLINE_ORDERING_LOCATION_PROPTYPES
);
